document.addEventListener('DOMContentLoaded', function () {
    var countdownElements = document.querySelectorAll('.countdown');
    countdownElements.forEach(function (el) {
        var endDateAttr = el.getAttribute('data-end-date');
        if (endDateAttr) {
            var endDate = new Date(endDateAttr).getTime();
            if (!isNaN(endDate)) {
                var timer = setInterval(function () {
                    var now = new Date().getTime();
                    var distance = endDate - now;
                    if (distance < 0) {
                        clearInterval(timer);
                        el.innerHTML = "EXPIRED";
                    } else {
                        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                        var seconds = Math.floor((distance % (1000 * 60)) / 1000);
                        el.innerHTML = days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
                    }
                }, 1000);
            } else {
                el.style.display = 'none';
            }
        } else {
            el.style.display = 'none';
        }
    });
});




